/* eslint-disable react-hooks/exhaustive-deps */
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Button, Chip } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { selectLocationState, useSelector } from "src/stateManagement/redux";

interface Props {
    show: any;
    setShowDetailMechanical: any;
}

const DiagramaMecanico = ({ show, setShowDetailMechanical }: Props) => {
    const { wellboreDiagram } = useSelector(selectLocationState);

    const [data, setData] = useState([])

    useEffect(() => {
        console.log({wellboreDiagram})
    }, [wellboreDiagram])
    

    const handleShowDetailMechanical = (): void => {
        setShowDetailMechanical(!show);
    };
    const columns: GridColDef[] = [
        { field: "programStartDate", headerName: "Fecha Programa", minWidth:100, flex: 1, headerClassName: 'wrap-header' },
        { field: "programEndDate", headerName: "Fecha Termino", minWidth:100,flex: 1, headerClassName: 'wrap-header' },
        { field: "totalDepth", headerName: "Prof Total", minWidth:100, flex: 1, headerClassName: 'wrap-header' },
        { field: "standingValveDepth", headerName: "Prof VF", minWidth:100, flex: 1, headerClassName: 'wrap-header' },
        { field: "pumpInstallationDate", headerName: "fecha Inst. Bomba", minWidth:150, flex: 1, headerClassName: 'wrap-header' },
        { field: "pumpSize", headerName: "Tamaño Bomba", minWidth:150, flex: 1, headerClassName: 'wrap-header' },
        { field: "plungerDiameter", headerName: "Diametro Piston", minWidth:150, flex: 1, headerClassName: 'wrap-header' },
        { field: "pumpBrand", headerName: "Tipo Bomba", minWidth:150, flex: 1, headerClassName: 'wrap-header' },
        { field: "tubingJointsQuantity", headerName: "Tipo Bomba", minWidth:150, flex: 1, headerClassName: 'wrap-header' },
        { field: "tubingDiameters", headerName: "Diametro Secciones de Tuberia", minWidth:150, flex: 1, headerClassName: 'wrap-header' },
        { field: "tubingLength", headerName: "Longitud Secciones de Tuberia", minWidth:150, flex: 1, headerClassName: 'wrap-header' },
        { field: "rodDiameters", headerName: "Diametro Secciones de Cabilla", minWidth:150, flex: 1, headerClassName: 'wrap-header' },
        { field: "rodLengths", headerName: "Longitud Secciones de Cabilla", minWidth:150, flex: 1, headerClassName: 'wrap-header' },
    ];

    const paginationModel = { page: 0, pageSize: 10 };
    return (
        <Grid container spacing={0}>
            <Grid size={12}>
                <DataGrid
                    rows={wellboreDiagram || []}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[10, 20, 50, 100]}
                    checkboxSelection={false}
                    sx={{
                        border: 0,
                        mt: 2,
                        "& .MuiDataGrid-columnHeader": {
                            backgroundColor: "#316EBC",
                            color: "#fff",
                            fontWeight: "bold",
                        },
                    }}
                    getRowId={(row) => row.id}
                />
            </Grid>
        </Grid>
    );
};

export default DiagramaMecanico;
